var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('navbar',{attrs:{"text":((_vm.$t('Configuration.name')) + " > " + (_vm.$t('Configuration.productsTitle')))}}),_vm._v(" "),(_vm.loaded)?_c('ProductsDatabase',{attrs:{"products":_vm.products}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }